
import { Component, Prop, Vue } from "vue-property-decorator";
import QRCode from "qrcode";

@Component({})
export default class QrCode extends Vue {
  @Prop()
  onScreen!: boolean;
  private qrCode: string | null = null;
  mounted() {
    QRCode.toDataURL(window.location.href).then((url: string) => {
      this.qrCode = url;
    });
  }
}
